function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.3702 17V15H13.5184V28H26.4813V15H24.6295V17H15.3702ZM17.2221 13C17.2221 12.2044 17.5147 11.4413 18.0357 10.8787C18.5566 10.3161 19.2631 10 19.9998 10C20.7365 10 21.4431 10.3161 21.964 10.8787C22.485 11.4413 22.7776 12.2044 22.7776 13H26.4813C26.9725 13 27.4435 13.2107 27.7908 13.5858C28.1381 13.9609 28.3332 14.4696 28.3332 15V28C28.3332 28.5304 28.1381 29.0391 27.7908 29.4142C27.4435 29.7893 26.9725 30 26.4813 30H13.5184C13.0272 30 12.5562 29.7893 12.2089 29.4142C11.8616 29.0391 11.6665 28.5304 11.6665 28V15C11.6665 14.4696 11.8616 13.9609 12.2089 13.5858C12.5562 13.2107 13.0272 13 13.5184 13H17.2221ZM19.9998 12C19.7543 12 19.5188 12.1054 19.3451 12.2929C19.1715 12.4804 19.0739 12.7348 19.0739 13C19.0739 13.2652 19.1715 13.5196 19.3451 13.7071C19.5188 13.8946 19.7543 14 19.9998 14C20.2454 14 20.4809 13.8946 20.6546 13.7071C20.8282 13.5196 20.9258 13.2652 20.9258 13C20.9258 12.7348 20.8282 12.4804 20.6546 12.2929C20.4809 12.1054 20.2454 12 19.9998 12Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -9.83407e-7,
  y1: 40,
  x2: 43.3889,
  y2: 4.09535,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#21A6C4"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#39DEB7"
})));

var SvgSurveyIcon = function SvgSurveyIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSurveyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/survey-icon.17497960.svg";
export { ForwardRef as ReactComponent };